import { render } from "./App.vue?vue&type=template&id=d1fce26e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d1fce26e&lang=css"

import exportComponent from "C:\\Users\\sato\\Desktop\\learncanvas\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__